import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertTOPComponent } from 'src/app/alert-top/alert-top.component';
import { ProposalService } from 'src/app/services/proposal.service';

@Component({
  selector: 'app-list-proposal',
  templateUrl: './list-proposal.component.html',
  styleUrls: ['./list-proposal.component.css']
})
export class ListProposalComponent implements OnInit {
  proposalList1: any[];
  proposalList2: any[];
  itemsCount: number;
  itemsCountRiwayat: number;
  pageSize: number;
  pageSizeRiwayat: number;
  pageArray: Array<number> = [];
  currentPage: number = 1;
  startIndex = 0;
  endIndex = 9;
  pageArrayRiwayat: Array<number> = [];
  currentPageRiwayat: number = 1;
  startIndexRiwayat = 0;
  endIndexRiwayat = 9;
  showPagination = false;
  showPaginationRiwayat = false;
  productName: string;
  searchProduct = "";
  isEmpty1: boolean;
  isEmpty2: boolean;
  isLoading1 = false;
  isLoading2 = false;
  activeTab = null;
  tab = '';
  filter = 4;

  constructor(
    private proposalService: ProposalService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activeTab = 'masih-berlaku';
    this.getProposal(this.searchProduct, 1, 0);

    this.route.params.subscribe((params) => {
      if (params["keyword"]) {
        this.activeTab = params["tab"] || 'masih-berlaku';
        if (this.activeTab == 'masih-berlaku') {
          this.getProposal(params["keyword"], 1, 0);
        } else {
          this.getProposal(params["keyword"], 2, 4);
        }
      } else {
        this.searchProduct = "";
        this.productName = "";
        this.isEmpty1 = false;
        this.isLoading1 = true;
        this.isEmpty2 = false;
        this.isLoading2 = true;
        this.getProposal(this.searchProduct, 1, 0);
        this.getProposal(this.searchProduct, 2, 4);
      }
    });
  }

  public getProposal(search: string, type: number, status: number) {
    this.proposalService.getProposal(
      search,
      status,
      (data) => {
        if (type === 1) {
          this.proposalList1 = data;
        } else {
          this.proposalList2 = data;
        }

        if (this.proposalList1 && this.proposalList1.length === 0) {
          this.isEmpty1 = true;
        } else {
          this.isEmpty1 = false;
        }

        if (this.proposalList2 && this.proposalList2.length === 0) {
          this.isEmpty2 = true;
        } else {
          this.isEmpty2 = false;
        }

        this.currentPage = 1;
        this.currentPageRiwayat = 1;
        this.itemsCount = this.proposalList1 && this.proposalList1.length;
        this.itemsCountRiwayat = this.proposalList2 && this.proposalList2.length;
        this.pageSize = Math.ceil(this.itemsCount / 9);
        this.pageSizeRiwayat = Math.ceil(this.itemsCountRiwayat / 9);
        this.pageArray = this.pageSize ? new Array(this.pageSize).fill(1) : [];
        this.pageArrayRiwayat = this.pageSizeRiwayat ? new Array(this.pageSizeRiwayat).fill(1) : [];

        if (this.itemsCount > 9) {
          this.showPagination = true;
        }

        if (this.itemsCountRiwayat > 9) {
          this.showPaginationRiwayat = true;
        }

        if (type === 1) {
          this.isLoading1 = false;
        } else {
          this.isLoading2 = false;
        }
      },
      (err) => { }
    );
  }

  public navigateToProposalDetail(proposal: any): void {
    localStorage.setItem(proposal.Draft_Order_Id, JSON.stringify(proposal));
    this.router.navigate([`proposal/detail/${proposal.Draft_Order_Id}`]);
  }

  public setPage(pageNumber) {
    this.currentPage = pageNumber;

    if (pageNumber == 1) {
      this.startIndex = 0;
      this.endIndex = 9;
    } else {
      pageNumber = pageNumber - 1;
      this.startIndex = 9 * pageNumber;
      this.endIndex = this.startIndex + 9;
    }
  }

  public setPageRiwayat(pageNumber) {
    this.currentPageRiwayat = pageNumber;

    if (pageNumber == 1) {
      this.startIndexRiwayat = 0;
      this.endIndexRiwayat = 9;
    } else {
      pageNumber = pageNumber - 1;
      this.startIndexRiwayat = 9 * pageNumber;
      this.endIndexRiwayat = this.startIndexRiwayat + 9;
    }
  }

  public onSearchProduct(searchTextValue: string) {
    if (searchTextValue === '') {
      if (this.activeTab == 'riwayat') {
        this.getProposal('', 2, 4);
        this.setPageRiwayat(1);
      } else {
        this.router.navigate(["proposal", {}]);
      }
      return;
    }

    if (searchTextValue == this.searchProduct) {
      // this.isLoading = false;

      this.route.params.subscribe((params) => {
        this.activeTab = params["tab"];
        if (this.activeTab == 'riwayat') {
          this.getProposal('', 2, 4);
          this.setPageRiwayat(1);
        } else {
          this.router.navigate(["proposal", {}]);
        }
      });
    } else {
      this.searchProduct = searchTextValue;
      this.showPagination = false;
      this.isEmpty1 = false;
      this.setPage(1);
      this.setPageRiwayat(1);
      if (searchTextValue != '') {
        this.router.navigate(["proposal", { keyword: this.searchProduct, tab: this.activeTab }]);
      } else {
        if (this.activeTab == 'riwayat') {
          this.getProposal('', 2, 4);
          this.setPageRiwayat(1);
        } else {
          this.router.navigate(["proposal", {}]);
        }
      }
      // this.isLoading = true;
    }
  }

  detail(type: string, id: any) {
    this.router.navigate([`proposal/detail/${type}/${id}`]);
  }

  tabMasihBerlaku() {
    this.activeTab = 'masih-berlaku';
    this.productName = '';
    this.isLoading1 = true;
    this.route.params.subscribe((params) => {
      this.activeTab = params["tab"];
      if (this.activeTab == 'riwayat') {
        this.activeTab = 'masih-berlaku';
      }

      this.router.navigate(["proposal", {}]);
      return;
    });

    this.getProposal('', 1, 0);
  }

  tabRiwayat() {
    this.activeTab = 'riwayat';
    this.productName = '';
    this.isLoading2 = true;
    this.filter = 4;
    this.route.params.subscribe((params) => {
      if (params["tab"]) {
        this.activeTab = params["tab"];
      }

      if (this.activeTab == 'masih-berlaku') {
        this.activeTab = 'riwayat';
        this.router.navigate(["proposal", {}]);
      } else {
        this.getProposal('', 2, 4);
        this.setPageRiwayat(1);
      }
    });
  }

  onChangeStatus(type: number) {
    this.getProposal(this.searchProduct, 2, type);
    this.setPageRiwayat(1);
  }

  getMyStatus(status: number) {
    switch (status) {
      case 0:
        return { name: 'Masih Berlaku', color: '' };
      case 1:
        return { name: 'Diterima', color: '#719849' };
      case 2:
        return { name: 'Ditolak', color: '#EB7664' };
      case 3:
        return { name: 'Sudah Lewat', color: '#4D4D4D' };
      case 4:
        return { name: 'All', color: '' };
    }
  }
}
